<template>
  <div class="ltvreport-wrap">
    <div class="report-name">LTV回收预测表</div>
    <div class="filter-wrap">
      <el-form :inline="true">
        <el-form-item label="日期">
          <el-date-picker
            v-model="filterData.time"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 320px"
            :picker-options="pickerOptions"
            value-format="yyyyMMdd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="维度">
          <el-select v-model="filterData.dimension">
            <el-option label="全部维度" :value="1"></el-option>
            <el-option label="国家和地区" :value="2"></el-option>
            <el-option label="渠道" :value="3"></el-option>
            <el-option label="campaign" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品">
          <product-select
            class="select-item"
            placeholder="产品"
            :value.sync="filterData.afid"
            @change="getCountrysByid"
            :isDefault="true"
          >
          </product-select>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select
            v-model="filterData.media"
            placeholder="全部"
            multiple
            collapse-tags
            @change="changeSelect"
            class="multipleselect"
            ref="chnlref"
            popper-class="app-select-self"
          >
            <div class="input-search">
              <el-input
                v-model="text"
                size="mini"
                suffix-icon="el-icon-search"
              />
            </div>
            <div style="text-align: right; padding-right: 10px">
              <el-checkbox
                v-model="checked"
                @change="selectAll($event, 'check')"
                >全选</el-checkbox
              >
            </div>
            <div @click="clickclear" class="clearbutton">
              <span style="font-size: 14px">清空</span>
            </div>

            <el-option
              v-for="item in mediaList.filter(
                (i) => !text || i.toLowerCase().includes(text.toLowerCase())
              )"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区">
          <areaMultiSelect
            :value.sync="filterData.geo"
            :optionsList="countryList"
          >
          </areaMultiSelect>
        </el-form-item>
        <el-form-item label="阈值">
          <el-input-number
            style="width: 120px"
            v-model="threshold"
            :precision="4"
            :step="0.0001"
            :min="0"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrap">
      <el-table
        :data="tableList"
        style="width: 100%"
        :max-height="tableMaxHeight"
        v-loading="loading"
      >
        <el-table-column
          v-for="item of tableCols"
          :prop="item.prop"
          :label="item.label"
          :key="item.label"
          :fixed="item.fixed"
          :width="item.width"
          align="center"
        >
          <el-table-column
            v-for="(childItem, index) of item.child"
            :prop="childItem.prop"
            :label="childItem.label"
            :key="index"
            :width="childItem.width"
            align="center"
            :fixed="childItem.fixed"
          >
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getMedias, countrys, ltvPredict } from "@/api/ltvReport.js";
import tableCols from "./columns";
import areaMultiSelect from "@/components/areaMultiSelect.vue";

export default {
  name: "LtvReport",
  components: {
    areaMultiSelect,
  },
  data() {
    return {
      tableMaxHeight: window.innerHeight - 170,
      checked: false,
      text: "",
      mediaList: [],
      countryList: [],
      filterData: {
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        dimension: 1,
        afid: -1,
        media: [],
        geo: [],
      },
      threshold: 0.0015, //阈值
      loading: false,
      tableList: [],
      tableCols: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(7, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(30, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
          {
            text: "最近二个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(60, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initSelect();
  },
  methods: {
    //产品下拉
    initSelect() {
      const timer = setInterval(() => {
        if (this.filterData.afid) {
          clearInterval(timer);
          this.searchData();
          this.getCountrysByid(this.filterData.afid);
        }
      }, 200);
      getMedias().then((res) => {
        if (res.code === "0000") {
          this.mediaList = res.mediaList;
        }
      });
    },
    getCountrysByid(afid) {
      this.filterData.geo = [];
      countrys({ afid }).then((res) => {
        if (res.code === "0000") {
          this.countryList = res.countryList;
        }
      });
    },
    changeSelect(value) {
      if (
        this.checked &&
        this.filterData.media.length < this.mediaList.length
      ) {
        this.checked = false;
        this.filterData.media = value;
      }
    },
    selectAll(event, value) {
      if (event) {
        this.filterData.media = this.mediaList;
      } else {
        value == "check" ? (this.filterData.media = []) : null;
      }
    },
    clickclear() {
      this.filterData.media = [];
    },
    formatData() {
      let data = {
        dateStart: this.filterData.time[0],
        dateEnd: this.filterData.time[1],
      };

      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (data[key] = checkData.join());
        } else {
          data[key] = checkData;
        }
      }

      return data;
    },
    changeColumns() {
      let newCols = [];
      switch (this.filterData.dimension) {
        case 1:
          newCols = [
            { label: "日期", prop: "installDay", fixed: true, width: 150 },
          ].concat(tableCols);
          break;
        case 2:
          newCols = [
            { label: "国家和地区", prop: "geo", fixed: true, width: 150 },
          ].concat(tableCols);
          break;
        case 3:
          newCols = [
            { label: "渠道", prop: "mediaSource", fixed: true, width: 150 },
          ].concat(tableCols);
          break;
        case 4:
          newCols = [
            { label: "渠道", prop: "mediaSource", fixed: true, width: 150 },
            { label: "campaign", prop: "campaign", fixed: true, width: 150 },
          ].concat(tableCols);
          break;
        default:
          break;
      }
      this.tableCols = newCols;
    },
    searchData() {
      this.loading = true;
      let parmas = this.formatData();
      ltvPredict({
        data: JSON.stringify(parmas),
        threshold: this.threshold,
      }).then((res) => {
        this.changeColumns();
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = res.ltvPreviewDatas.map((item) => {
            item.ecpi = item.ecpi === 0 ? 0 : item.ecpi.toFixed(2);
            item.p30_ltv = item.p30_ltv === 0 ? 0 : item.p30_ltv.toFixed(2);
            item.p30_roi = item.p30_roi === 0 ? 0 : item.p30_roi.toFixed(2);
            item.p23_ltv = item.p23_ltv === 0 ? 0 : item.p23_ltv.toFixed(2);
            item.p23_roi = item.p23_roi === 0 ? 0 : item.p23_roi.toFixed(2);
            item.p16_ltv = item.p16_ltv === 0 ? 0 : item.p16_ltv.toFixed(2);
            item.p16_roi = item.p16_roi === 0 ? 0 : item.p16_roi.toFixed(2);
            item.p9_ltv = item.p9_ltv === 0 ? 0 : item.p9_ltv.toFixed(2);
            item.p9_roi = item.p9_roi === 0 ? 0 : item.p9_roi.toFixed(2);
            return item;
          });
          console.log(res.ltvPreviewDatas);
        }
      });
    },
    filterOptions(value) {
      this.filterProductList = this.allProductList.filter((item) => {
        let valueStr = String(value);
        return (
          item.appName.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.afid.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.dbtId?.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ltvreport-wrap {
  padding: 16px;
  box-sizing: border-box;
  .report-name {
    padding: 0px 16px 6px 0px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .filter-wrap {
    margin-top: 10px;
    .multipleselect ::v-deep .el-input__inner {
      &::placeholder {
        color: #777777 !important;
      }
    }
    .input-search {
      width: 90%;
      margin-left: 5%;
    }
  }
}
</style>
